import React, { useRef, useState, useCallback } from "react";

/**
 * BeforeAfterSlider
 * - drag the divider to compare before/after images
 */
export default function BeforeAfterSlider({ before, after, beforeLabel = "Before", afterLabel = "After" }) {
  const containerRef = useRef(null);
  const [pos, setPos] = useState(50);
  const draggingRef = useRef(false);

  const updateFromClient = useCallback((clientX) => {
    const rect = containerRef.current?.getBoundingClientRect();
    if (!rect) return;
    const x = Math.min(Math.max(clientX - rect.left, 0), rect.width);
    setPos((x / rect.width) * 100);
  }, []);

  const onDown = (e) => {
    draggingRef.current = true;
    const cx = e.touches ? e.touches[0].clientX : e.clientX;
    updateFromClient(cx);
  };
  const onMove = (e) => {
    if (!draggingRef.current) return;
    const cx = e.touches ? e.touches[0].clientX : e.clientX;
    updateFromClient(cx);
  };
  const onUp = () => { draggingRef.current = false; };

  return (
    <div
      ref={containerRef}
      className="relative w-full aspect-[16/10] rounded-2xl overflow-hidden select-none bg-slate-900"
      onMouseMove={onMove}
      onMouseUp={onUp}
      onMouseLeave={onUp}
      onTouchMove={onMove}
      onTouchEnd={onUp}
      data-testid="before-after-slider"
    >
      <img src={after} alt="after" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
        <img src={before} alt="before" className="absolute inset-0 w-full h-full object-cover" style={{ width: `${(100 / pos) * 100}%`, maxWidth: "none" }} />
      </div>

      <div className="absolute top-4 left-4 px-3 py-1 rounded-full bg-black/60 text-white text-xs font-medium">{beforeLabel}</div>
      <div className="absolute top-4 right-4 px-3 py-1 rounded-full bg-primary text-white text-xs font-medium">{afterLabel}</div>

      <div
        className="absolute top-0 bottom-0 w-1 bg-white cursor-ew-resize"
        style={{ left: `${pos}%`, transform: "translateX(-50%)" }}
        onMouseDown={onDown}
        onTouchStart={onDown}
      >
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-11 w-11 rounded-full bg-white shadow-lg flex items-center justify-center">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0F4C81" strokeWidth="2.5">
            <path d="M15 18l-6-6 6-6" /><path d="M9 6l6 6-6 6" transform="translate(0,0)"/>
          </svg>
        </div>
      </div>
    </div>
  );
}
